/**
 * Debug logging for V1 vs CMOE parity during dual-write (Phase 2).
 * @param {string} code
 * @param {Record<string, unknown>} [detail]
 */
export function logCmoeSyncInfo(code, detail = {}) {
  if (process.env.NODE_ENV === "test") return;
  console.info("[cmoe-sync]", code, detail);
}

/**
 * @param {string} code
 * @param {Record<string, unknown>} [detail]
 */
export function logCmoeSyncMismatch(code, detail = {}) {
  if (process.env.NODE_ENV === "test") return;
  console.warn("[cmoe-sync:mismatch]", code, detail);
}

/**
 * @param {string} code
 * @param {unknown} err
 * @param {Record<string, unknown>} [detail]
 */
export function logCmoeSyncError(code, err, detail = {}) {
  if (process.env.NODE_ENV === "test") return;
  console.warn("[cmoe-sync:error]", code, detail, err);
}
